<template>
    <div v-if="productData.service" id="service-variants" class="variant-list mx-auto px-2">
        <h2 class="my-4">
            <strong>{{ $t('serviceDetail.qualityVariant') }}</strong>
        </h2>

        <template v-if="productData.service.variants.length > 0">
            <Variant
                v-for="(variant, key) in productData.service.variants"
                :key="key"
                :product-id="variant.id"
                :name="variant.name"
                :price="variant.price"
                :valid-till="variant.validTill"
                :how-to-use="productData.howToUse"
                :included-in-price="productData.includedInPrice"
                :is-open="key === 0"
                :is-published="productData.status === 1"
                :product="productData"
            />
        </template>
        <template v-else>
            <Variant
                :product-id="productData.id"
                :name="productData.name"
                :price="productData.price"
                :valid-till="productData.service.validTill"
                :included-in-price="productData.service.includedInPrice"
                :how-to-use="productData.service.howToUse"
                :is-open="true"
                :is-published="productData.status === 1"
            />
        </template>
    </div>
</template>

<script lang="ts">
// @ts-nocheck
import Variant from '~/components/layout/productDetail/Variant.vue'

export default {
    components: { Variant },

    props: {
        productData: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.variant-list {
    max-width: 900px;
}
</style>
